import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import api from '../lib/api';
import { sanitizeHtml } from '../lib/sanitize';

export default function ArticleDetail() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get(`/articles/${slug}`); setArticle(data); }
      catch { setNotFound(true); }
    })();
  }, [slug]);

  if (notFound) return (
    <div className="pt-32 pb-24 text-center">
      <h1 className="font-serif text-cream-50 text-4xl">Article not found</h1>
      <Link to="/insights" className="mt-6 inline-block text-sage-400 hover:underline">Back to Insights</Link>
    </div>
  );
  if (!article) return <div className="pt-32 text-center text-cream-100/60">Loading…</div>;

  return (
    <div className="pt-24">
      <section className="relative py-28 bg-forest-950">
        {article.cover && <div className="absolute inset-0 opacity-25"><img src={article.cover} alt="" className="w-full h-full object-cover" /><div className="absolute inset-0 bg-gradient-to-b from-forest-950 via-forest-950/80 to-forest-900" /></div>}
        <div className="relative max-w-4xl mx-auto px-6 md:px-10">
          <Link to="/insights" className="inline-flex items-center gap-2 text-cream-100/70 hover:text-sage-400 text-sm mb-6"><ArrowLeft className="h-4 w-4" /> All Insights</Link>
          <p className="text-sage-400 tracking-[0.3em] text-xs uppercase mb-4">{article.tag}</p>
          <h1 className="font-serif text-cream-50 text-4xl md:text-6xl leading-tight">{article.title}</h1>
          <p className="mt-6 text-cream-100/70 text-sm">{new Date(article.created_at).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
        </div>
      </section>
      <section className="bg-forest-900 py-20">
        <div className="max-w-3xl mx-auto px-6 md:px-10 prose-invert text-cream-100/85 text-lg leading-relaxed">
          {/* Body is server-sanitised (bleach) so safe to render */}
          <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(article.body.replace(/\n/g, '<br />')) }} />
        </div>
      </section>
      <section className="bg-forest-950 py-16">
        <div className="max-w-3xl mx-auto px-6 md:px-10 text-center">
          <p className="text-cream-100/75">Speak to our team about how this affects you.</p>
          <Link to="/contact" className="mt-6 inline-flex items-center gap-3 bg-sage-500 text-forest-900 px-8 py-3 text-sm font-medium hover:bg-sage-600 transition-colors">Contact Us <ArrowRight className="h-4 w-4" /></Link>
        </div>
      </section>
    </div>
  );
}
